import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { getPaymentManagementModuleName } from './payment-management.permissions';

export class PaymentConfigurationsPermissions {
  static GroupName = `${getPaymentManagementModuleName()}.PaymentConfigurations`;

  static getPermissions = getGroupPermissionFactory(PaymentConfigurationsPermissions.GroupName);

  static Permissions = {
    Read: PaymentConfigurationsPermissions.getPermissions(PermissionEnum.READ),
    ReadAll: PaymentConfigurationsPermissions.getPermissions(PermissionEnum.READ_ALL),
  };
}